module.exports = __webpack_public_path__ + "img/fig06.0c1b42f7.jpg";